import { render, staticRenderFns } from "./IngresoTable.vue?vue&type=template&id=cd6cddf8&scoped=true"
import script from "./IngresoTable.vue?vue&type=script&lang=js"
export * from "./IngresoTable.vue?vue&type=script&lang=js"
import style0 from "./IngresoTable.vue?vue&type=style&index=0&id=cd6cddf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6cddf8",
  null
  
)

export default component.exports